var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-2", class: ["col-" + _vm.colSize] }, [
    _c("div", { staticClass: "form-page" }, [
      _c("p", { staticClass: "text-justify" }, [
        _vm._v("\n      " + _vm._s(_vm.prompt) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "article",
        { staticClass: "mb-0", class: _vm.articleClass },
        _vm._l(_vm.options, function (option) {
          return _c(
            "div",
            {
              key: option.id,
              staticClass: "form-container fe-radio-form large-radio px-3",
              class: "ml-" + _vm.margin,
            },
            [
              option.multi
                ? _c("div", { staticClass: "row align-items-center" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-icon p-jelly p-smooth p-curve my-3",
                        class: option.multiLine ? "w-70 multi-line" : "",
                      },
                      [
                        _c("input", {
                          staticClass: "checkbox",
                          attrs: {
                            id: option.id,
                            name: option.id,
                            type: "checkbox",
                            disabled: _vm.disabled,
                          },
                          domProps: {
                            value: option.value,
                            checked: _vm.checkedMap[option.value],
                          },
                          on: { change: _vm.handleMultiChange },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-success" }, [
                          _c("i", { staticClass: "icon fa fa-check" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              attrs: { for: option.id },
                              on: {
                                click: function ($event) {
                                  _vm.answer.option = option.value
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(option.text) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      option.textAreaInsideLabel === "right"
                        ? _c("textarea", {
                            staticClass: "mx-1 pl-1",
                            attrs: {
                              id: "textarea-" + option.id,
                              rows: option.rows,
                              cols: option.cols,
                              disabled: !_vm.checkedMap[option.value],
                            },
                            domProps: {
                              value: _vm.textareaValue(option.value),
                            },
                            on: {
                              change: function ($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleTextareaChange.apply(
                                  void 0,
                                  [option.value].concat(argsArray)
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                  ])
                : _c(
                    "div",
                    {
                      staticClass: "fe-option col-xs-12 d-inline-block",
                      class: option.multiLine
                        ? "w-70 multi-line my-3 h-auto"
                        : "",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.answer.option,
                            expression: "answer.option",
                          },
                        ],
                        attrs: {
                          id: option.id,
                          type: "radio",
                          disabled: _vm.disabled,
                        },
                        domProps: {
                          value: option.value,
                          checked: _vm._q(_vm.answer.option, option.value),
                        },
                        on: {
                          change: [
                            function ($event) {
                              return _vm.$set(
                                _vm.answer,
                                "option",
                                option.value
                              )
                            },
                            _vm.handleChange,
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkmark" }),
                      _vm._v(" "),
                      option.textAreaInsideLabel
                        ? _c(
                            "label",
                            {
                              attrs: { for: option.id },
                              on: {
                                click: function ($event) {
                                  _vm.answer.option = option.value
                                },
                                change: _vm.handleExplainChange,
                              },
                            },
                            [
                              _c("textarea", {
                                style: {
                                  order: _vm.getOrder(
                                    option.textAreaInsideLabel
                                  ),
                                },
                                attrs: {
                                  id: "textarea-" + option.id,
                                  rows: "1",
                                },
                                domProps: {
                                  value:
                                    _vm.answer.option == option.value
                                      ? _vm.answer.text
                                      : "",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "px-1",
                                  class: {
                                    "text-light":
                                      _vm.answer.option === option.value,
                                  },
                                  attrs: { for: "textarea-" + option.id },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(option.text) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _c(
                            "label",
                            {
                              attrs: { for: "" + option.id },
                              on: { change: _vm.handleExplainChange },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(option.text) +
                                  "\n          "
                              ),
                            ]
                          ),
                    ]
                  ),
              _vm._v(" "),
              option.comparison
                ? _c(
                    "p",
                    {
                      staticClass: "mt-3 text-uppercase",
                      class: { bold: option.boldComparison },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.words.or")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              option.multipleOptions
                ? _c(
                    "div",
                    {
                      staticClass:
                        "form-group-material form-group-material-no-label",
                    },
                    [
                      _c("multiple-options-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: option.value == _vm.answer.option,
                            expression: "option.value == answer.option",
                          },
                        ],
                        attrs: {
                          options: option.list,
                          value: _vm.answer,
                          rows: "1",
                          cols: "30",
                        },
                        on: { input: _vm.handleSecondOptionChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              option.multi && option.withPriorEncumbrances
                ? _c(
                    "div",
                    [
                      _c(_vm.inputComponent("priorEncumbrances"), {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.answer.some(function (obj) {
                              return (
                                obj == option.value || obj.value == option.value
                              )
                            }),
                            expression:
                              "\n              answer.some(\n                obj => obj == option.value || obj.value == option.value\n              )\n            ",
                          },
                        ],
                        tag: "component",
                        attrs: {
                          id: option.id,
                          value:
                            _vm.findElement(
                              _vm.noYesInputValue(),
                              option.value
                            ) || {},
                          prompt: option.prompt,
                          "explain-label": option.explainLabel,
                          "extra-options": option.extraOptions,
                          "show-textarea": option.extraComponent,
                          "textarea-label": option.textareaLabel,
                          inline: option.inline,
                          "col-size": _vm.colSize,
                          cols: option.cols,
                          rows: option.rows,
                          resize: option.resize,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handleNoYesInput(option.value, $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              option.textExplain && !option.withNoYesInput
                ? _c(
                    "div",
                    [
                      _c(_vm.inputComponent(option.textExplainType), {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.answer.option == option.value,
                            expression: "answer.option == option.value",
                          },
                        ],
                        tag: "component",
                        staticClass: "mw-100",
                        attrs: {
                          title: option.textExplainLabel || "",
                          prompt: option.textExplainLabel || "",
                          value:
                            option.textExplainType == "date"
                              ? _vm.answer.date
                              : _vm.answer.text,
                          "explain-label": option.explainLabel,
                          cols: option.cols,
                          rows: option.rows,
                          resize: option.resize,
                        },
                        on: { input: _vm.handleExplainChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }